
//**********************************************
// 対象となる要素の動きを監視して処理（後からjavascriptで追加された要素など）
//**********************************************
// 監視対象のノードを選択（'selectID'というIDを持つタグを指定）
var targetNode = document.getElementById('product-form-template--22940303524141__main');

// MutationObserverの設定
var config = { childList: true, subtree: true };

// 変更が発見されたときに実行されるコールバック関数
const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {



        $('.gpo-tooltip__title > span').each(function () {
            var txt = $(this).html();
            $(this).html(
                txt.replace(/・/g, '<br>')
            );
        });
    }
    observer.disconnect();
};
// MutationObserverのインスタンスを作成
var observer = new MutationObserver(callback);

// 監視を開始
observer.observe(targetNode, config);